module.exports = __webpack_public_path__ + "static/media/kariba_loading_icon.bda4521d.svg";